import React from "react";
import { Logo } from "../Logo";
import { useLanguage } from "../../context/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-slate-800 bg-slate-950 py-16 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo />
            <p
              className="mt-5 text-sm text-slate-400 max-w-sm"
              style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
            >
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-2">
            <p
              className="text-[11px] tracking-[0.2em] uppercase text-slate-500 mb-4"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              {t.footer.sections.company}
            </p>
            <ul className="space-y-2.5">
              <li>
                <a href="#about" className="text-sm text-slate-300 hover:text-slate-50 transition-colors" data-testid="footer-link-about">
                  {t.footer.links.about}
                </a>
              </li>
              <li>
                <a href="#process" className="text-sm text-slate-300 hover:text-slate-50 transition-colors" data-testid="footer-link-process">
                  {t.footer.links.process}
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-slate-300 hover:text-slate-50 transition-colors" data-testid="footer-link-services">
                  {t.footer.links.services}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p
              className="text-[11px] tracking-[0.2em] uppercase text-slate-500 mb-4"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              {t.footer.sections.services}
            </p>
            <ul className="space-y-2.5">
              <li>
                <a href="#services" className="text-sm text-slate-300 hover:text-slate-50 transition-colors">
                  {t.footer.links.custom}
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-slate-300 hover:text-slate-50 transition-colors">
                  {t.footer.links.saas}
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-slate-300 hover:text-slate-50 transition-colors">
                  {t.footer.links.integrations}
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-slate-300 hover:text-slate-50 transition-colors">
                  {t.footer.links.consulting}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p
              className="text-[11px] tracking-[0.2em] uppercase text-slate-500 mb-4"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              {t.footer.sections.contact}
            </p>
            <a
              href="mailto:support@bluebrotherstech.com"
              className="text-sm text-slate-50 hover:text-blue-300 transition-colors"
              data-testid="footer-email-link"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              support@bluebrotherstech.com
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-slate-800 flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
          <p
            className="text-xs text-slate-500"
            style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
            data-testid="footer-rights"
          >
            © {year} BlueBrotherstech. {t.footer.rights}
          </p>
          <p
            className="text-[10px] tracking-[0.25em] uppercase text-slate-600"
            style={{ fontFamily: "'IBM Plex Mono', monospace" }}
          >
            Built with engineering rigor.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
